import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
const testimonials = [{
  quote: 'Sentía que él estaba ausente y en realidad estaba aterrado de decir algo mal. Con el mapa de emociones del Tomo 1 entendimos en una noche lo que no habíamos podido hablar en dos meses.',
  author: 'Marina L.',
  context: 'Buenos Aires — Semana 32 de embarazo'
}, {
  quote: 'Las cartas de conversación se volvieron nuestro ritual de los domingos. Pasamos de discutir por la mesa sin tender a hablar de lo que de verdad nos daba miedo.',
  author: 'Federico G.',
  context: 'Córdoba — Primer hijo en camino'
}, {
  quote: 'Tengo el tracker de nosotros desde la semana 6. Ver el número subir semana a semana me da más tranquilidad que cualquier lista de compras del bebé.',
  author: 'Julieta R.',
  context: 'Rosario — Semana 24 de embarazo'
}];
export function Testimonials() {
  return <section className="py-10 md:py-16 px-4 md:px-8 bg-offwhite" data-id="element-298">
      <div className="max-w-7xl mx-auto" data-id="element-299">
        <div className="grid md:grid-cols-3 gap-4 md:gap-8" data-id="element-300">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-cream p-5 md:p-8 rounded-2xl relative" data-id="element-301">
              <Quote className="absolute top-4 right-4 md:top-6 md:right-6 text-terracotta/20" size={32} data-id="element-302" />
              <p className="font-sans text-sm md:text-base text-brown/80 italic mb-4 md:mb-6 relative z-10" data-id="element-303">
                "{t.quote}"
              </p>
              <div data-id="element-304">
                <p className="font-serif font-bold text-brown text-sm md:text-base" data-id="element-305">
                  {t.author}
                </p>
                <p className="font-sans text-xs md:text-sm text-terracotta" data-id="element-306">
                  {t.context}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}